export const isManagedWorkflow = (workflow) => (
  ['organization', 'user_group'].includes(workflow.owner_type)
)

export const isWorkflowAttachedToEventType = (workflow, eventTypeId, parentId) => (
  workflow.event_types?.some((eventType) => {
    if (parentId === null && eventType.id === null) return false

    return String(eventType.id) === String(eventTypeId) || String(eventType.id) === String(parentId)
  })
)

export const buildWorkflowEventTypeIds = (workflow, eventTypeId, shouldAttach) => {
  const existingIds = (workflow.event_types || []).map(({ id }) => id)

  if (shouldAttach) {
    if (existingIds.some((id) => String(id) === String(eventTypeId))) return existingIds

    return [...existingIds, eventTypeId]
  }

  return existingIds.filter((id) => String(id) !== String(eventTypeId))
}
